import React from 'react';
import Select from '../../../../../components/shared/Select/Select';

interface LanguageSelectorProps {
  value?: string;
  onChange?: (value: string) => void;
  id?: string;
}

const languageOptions = [
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Spanish' },
  { value: 'fr', label: 'French' },
  { value: 'de', label: 'German' },
  { value: 'it', label: 'Italian' },
  { value: 'pt', label: 'Portuguese' },
];

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ value, onChange, id = 'language' }) => {
  return (
    <Select
      label="Language"
      id={id}
      value={value}
      options={languageOptions}
      onChange={onChange}
      className="setting-select"
    />
  );
};

export default LanguageSelector;
